import { ProductType } from './ProductTypeApi';
import { QueryKey } from '@/configs/queryKeys';
import { Component } from './ComponentApi';
import { Attachment, UUID } from '@/types/types';
import { CreatorSelectedAttributesValues } from '@/types/creator';
import httpClient from './httpClient';
import EntityApi, { BaseEntity } from './EntityApi';

export enum ProductStatus {
	NOT_ADDED,
	ADDDED_TO_CART,
}

export interface ProductComponent extends BaseEntity {
	product: Product;
	quantity: number;
	netPrice: number;
	grossPrice: number;
	componentData: Component & { price: number };
}

export type ProductOptions = {
	productId: UUID | null;
	selectedAttributes: CreatorSelectedAttributesValues;
};

export interface Product extends BaseEntity {
	netPrice: number;
	grossPrice: number;
	productType: ProductType | null;
	productComponents: ProductComponent[];
	status: ProductStatus;
	options: ProductOptions;
	image?: Attachment;
	width: number;
	height: number;
	quantity: number;
}

class ProductApi extends EntityApi<Product> {
	constructor() {
		super(QueryKey.products);
		this.updateCompontents = this.updateCompontents.bind(this);
		this.submit = this.submit.bind(this);
	}

	async updateCompontents({
		productId,
		components,
	}: {
		productId: UUID;
		components: { id: UUID }[];
	}) {
		const response = await httpClient.patch<Product>(
			`${this.queryKey}/${productId}/components`,
			{ components }
		);

		return response.data;
	}

	async submit({
		productId,
		options,
	}: {
		productId: UUID;
		options: ProductOptions;
	}) {
		const response = await httpClient.patch<Product>(
			`${this.queryKey}/${productId}`,
			{
				status: ProductStatus.ADDDED_TO_CART,
				options,
			}
		);

		return response.data;
	}
}

export default new ProductApi();
